import { useEffect, useLayoutEffect } from 'react';

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}

export { useIsomorphicLayoutEffect };


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/esm/react/use-isomorphic-layout-effect.js
// module id = 111
// module chunks = 0